import CreditCardIcon from "@components/CreditCard/CreditCardIcon";
import useContent from "@lib/use_content";
import classNames from "classnames";

interface TokenizedProps {
  className?: string;
  tokenizedCard: be.TokenizedCreditCard;
}

function Tokenized({ className, tokenizedCard }: TokenizedProps): JSX.Element | null {
  const { data } = useContent(["bePaymentCcTokenizedEndingIn", "bePaymentCcTokenizedExpires"]);

  return tokenizedCard?.numberLast4 ? (
    <dd className={classNames(className, "-ml-4 -mt-4 flex flex-wrap")}>
      <div className="ml-4 mt-4 shrink-0">
        <CreditCardIcon typeCode={tokenizedCard.typeCode} />
      </div>
      <div className="ml-4 mt-4">
        <p className="text-gray-500">
          {data?.content.bePaymentCcTokenizedEndingIn} {tokenizedCard.numberLast4?.substr(-4)}
        </p>
        {tokenizedCard.expiration && (
          <p className="text-gray-500">
            {data?.content.bePaymentCcTokenizedExpires} {tokenizedCard.expiration.substring(0, 2)} /{" "}
            {tokenizedCard.expiration.substring(2, 6)}
          </p>
        )}
      </div>
    </dd>
  ) : null;
}

export default Tokenized;
